<template>
  <input-container
    class="row no-gutters"
    @updateValidity="updateDiscountValidity">

    <div class="price col-8 col-sm-9 col-md-6 col-lg-4">
      <input-number
          variant="standardInput"
          :inputName="inputName"
          :inputLabel="$t('MpeEditor.input.discount.label')"
          :inputValue="getDisplayDiscount"
          :constraints="getDiscountConstraints"
          :inputPlaceholder="$t('Services.discountPlaceholder')"
          required
          stretched
          smaller

          @fieldUpdate="updateDiscountValue"/>
    </div>

    <div v-if="canBeChanged" class="discount-type col-4 col-sm-3 col-md-3 col-lg-2">
      <input-select 
        class="select-input ml-0 ml-md-2"
        variant="standardInput"
        inputName="discountType"
        
        smaller
        stretched
        :defaultValue="getDefaultDiscountType"
        :selectOptions="getDiscountTypeOptions"
        @fieldUpdate="updateDiscountTypeValue"/>
    </div>

    <div v-else class="discount-type-static col-1 col-sm-1 col-md-1 col-lg-1">
      <span>
        {{getDiscountTypeSymbol}}
      </span>
    </div>
  </input-container>
</template>

<script>
import InputNumber from '@/components/standard/input/InputNumber'
import InputSelect from '@/components/standard/input/InputSelect'
import InputContainer from '@/components/standard/input/InputContainer'

import cb from '@/assets/modules/constraints/constraintBuilder'
import dc from '@/assets/modules/events/discountCalculator'
import stylers from '@/mixins/components/standard/input/inputButton/stylers'

export default {
  data () {
    return {
      discountType: 'rel'
    }
  },
  methods: {
    /**
     * Updates discount's validity
     * @param {Object} e
     */
    updateDiscountValidity (e) {
      this.$emit('updateValidity', e)
    },

    /*
     * Updates discount type and converts discount based on discountType.
     * @param {Object} e
     */
    updateDiscountTypeValue (e) {
      this.discountType = e.value
      let value = this.inputValue
      if (value !== null) {
        if (this.discountType === 'rel') {
          value /= -100
        } else {
          value *= -100
        }
      } else {
        value = 0
      }

      this.$emit('fieldUpdate', {value: value, input: this.inputName})
    },

    /**
     * Catches inputNumber's field update and alteres the output based on 
     * discount type.
     * @param {Object} e
     */
    updateDiscountValue (e) {
      let { value } = e
      if (this.discountType === 'abs') value *= -1
      else value /= 100
      e.value = value
      this.$emit('fieldUpdate', e)
    }
  },

  computed: {
    /**
     * Gives discount that should be displayed in the input, based on 
     * discount type
     * @returns {Number}
     */
    getDisplayDiscount () {
      return dc.getDiscount(this.inputValue).discount
    },

    /**
     * Gives discount type based on inputValue
     *  @returns {String}
     */
    getDefaultDiscountType () {
      if (this.inputValue < 0) {
        this.discountType = 'abs'
        return 'abs'
      } else if (this.inputValue > 0) {
        this.discountType = 'rel'
        return  'rel'
      } else {
        return this.discountType
      }
    },

    /**
     * Gives types of discount
     * @returns {Array}
     */
    getDiscountTypeOptions () {
      return [
        {
          label: '%',
          val: 'rel'
        },
        {
          label: '€',
          val: 'abs'
        }
      ]
    },

    /**
     * Gives discount constraints. Builds them based on discount type
     * @returns {Object}
     */
    getDiscountConstraints () {
      let rtr = cb.build('discount', {onInit: true, required: true})
      if (this.discountType === 'abs') {
        rtr.ge = 0
        rtr.le = this.price
        if (this.getDisplayDiscount > this.price) {
          rtr.errorMsg = 'Input.constraint.absDiscountToHigh.errorMsg'
        }
      } else {
        rtr.ge = 0
        rtr.le = 100
        if (this.getDisplayDiscount > 100) {
          rtr.errorMsg = 'Input.constraint.relDiscountToHigh.errorMsg'
        }
      }

      return rtr
    },

    /**
     * Gives symbol based on discountType
     * @returns {String}
     */
    getDiscountTypeSymbol () {
      if (this.discountType === 'abs') return '€'
      return '%'
    }
  },

  components: {
    'input-number': InputNumber,
    'input-select': InputSelect,
    'input-container': InputContainer
  },

  mixins: [
    stylers
  ],

  props: {
    inputValue: {
      type: Number,
      required: false
    },
    price: {
      type: Number,
      required: false
    },
    canBeChanged: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
.select-input-box {
  margin-top: 10px;
}

.select-input-box {
  display: flex;
  align-items: flex-end;
  font-size: 13px;
  padding-bottom: 10px;
  font-weight: bold;
}

.discount-type-static {  
  padding-left: 10px;
  margin-top: 32px;
  font-weight: bold;
}

.discount-type {
  padding-left: 10px;
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/standard/input/InputDiscount.vue?7dcb6e2a